.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}

.buttonsSection {
  display: flex;
  justify-content: space-between;
}

.content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 var(--spacingLg);
  flex: 1;
}
